import React, { useState, useEffect } from "react";
import { Sidebar, Navbar, UserProfile, Cart, Notification, ThemeSettings, Chat } from "./";
import { FiSettings } from "react-icons/fi";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { useSelector } from "react-redux";

const HamburgerMenu = ({children}) => {

    const { status } = useSelector(state => state?.authSlice)

  const [activeMenu, setActiveMenu] = useState(true);
  const [currentColor, setCurrentColor] = useState(
    localStorage.getItem("colorMode") || "#03C9D7"
  );
  const [currentMode, setCurrentMode] = useState(localStorage.getItem('themeMode') || 'Dark')

  const [isClicked, setIsClicked] = useState({
    cart: false,
    chat: false,
    notification: false,
    userProfile: false,
  });

  //console.log(isClicked, "isClicked")

  const [themeSettings, setThemeSetting] = useState(false)

  useEffect(() => {
    localStorage.setItem("colorMode", currentColor);
    localStorage.setItem("themeMode", currentMode);
  }, [currentColor, currentMode]);

  const handleClick = (clicked) => {
    setIsClicked((prev) => ({ ...prev, [clicked]: !prev[clicked] }));
  };

  const setColor = (color) => {
    setCurrentColor(color)
  }

  const setMode = (mode) => {
    setCurrentMode(mode)
  }

  const setThemeSettings = (value) => {
    setThemeSetting(value)
  }

  return (
    <div className={currentMode === 'Dark' ? 'dark' : ''}>
            <div className="flex relative dark:bg-main-dark-bg">
              {status && (
                <div className="fixed right-4 bottom-4" style={{ zIndex:'' }}>
                <TooltipComponent
                content='Settings'
                position='Top'
                >
                  <button
                  type='button'
                  onClick={() => setThemeSettings(true)}
                  style={{ backgroundColor:currentColor, borderRadius:'50%'}}
                  className='text-3xl text-white p-3 drop-shadow-xl hover:bg-light-gray'
                  >
                    <FiSettings/>
                  </button>
                </TooltipComponent>
              </div>
            )}
      {/* Sidebar */}

      {status && activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white z-10">
          <Sidebar 
            activeMenu={activeMenu}
            setActiveMenu={setActiveMenu}
            currentColor={currentColor}
            handleClick={handleClick}
            isClicked={isClicked}
            currentMode={currentMode}
          />
        </div>
      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
            <Sidebar 
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
              currentColor={currentColor}
              handleClick={handleClick}
              isClicked={isClicked}
              currentMode={currentMode}
            />
          </div>
      )}

      <div
        className={
          activeMenu
                ? 'dark:bg-main-dark-bg bg-main-bg min-h-screen md:ml-72 w-full'
                : 'bg-main-bg dark:bg-main-dark-bg w-full min-h-screen flex-2'
            }
      >

     {/* Main Content */}
     {/* Render Navbar only if not on login page */}
      {status && (
        <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full">
          <Navbar 
             activeMenu={activeMenu}
             setActiveMenu={setActiveMenu}
             currentColor={currentColor}
             handleClick={handleClick}
             isClicked={isClicked}
             currentMode={currentMode}
          />
        </div>
      )}

        {themeSettings && <ThemeSettings 
            currentColor={currentColor} 
            currentMode={currentMode}
            setColor={setColor} 
            setMode={setMode} 
            setThemeSettings={setThemeSettings}
        />}

         {/* Render the main content */}
         {children}


        {isClicked?.notification && <Notification currentColor={currentColor} isClicked={isClicked} handleClick={handleClick}/>}
        {isClicked?.chat && <Chat currentColor={currentColor} isClicked={isClicked} handleClick={handleClick}/>}
        {isClicked?.cart && <Cart currentColor={currentColor} isClicked={isClicked} handleClick={handleClick}/>}
        {isClicked?.userProfile && <UserProfile currentColor={currentColor} isClicked={isClicked} handleClick={handleClick}/>}


        
      </div>
    </div>
    </div>
  )
}

export default HamburgerMenu;
